<template>
  <router-link :to="{ name: 'MovieDetail', params: { slug: string_to_slug(network.name), id:network.id }}" class="city-card" @click.native="onSelect()">
    <img :src="'http://image.tmdb.org/t/p/w185/' + network.poster_path" alt="" class="city-card__cover">
    <div class="city-card__overlay">
      <div class="city-card__title">{{ network.title }}</div>
      <div class="city-card__subtitle">See all episodes</div>
      <div class="city-card__number">{{ network.dorms_count }}</div>
    </div>
    <div class="city-card__cnt">
      <v-link
        class="city-card__button"
        :to="{ name: 'MovieDetail', params: { slug: string_to_slug(network.name), id:network.id }}"
        title="Inspect Episodes"
      />
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'NetworkCard',
  props: {
    network: Object
  },
  methods: {
    onSelect() {
      window.localStorage.setItem('district_name', '')
      window.localStorage.setItem('studio', this.network.name)
      window.localStorage.setItem('genre', this.network.id)
    },
        string_to_slug (str) {
        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()
  
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        var to   = "aaaaeeeeiiiioooouuuunc------"
        for (var i=0, l=from.length ; i < l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes

        return str
    },    
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/components/city-card";
</style>
